import type { FaireProductEntity } from "../../entity_types/product";

export const p_3c8krf49h6: FaireProductEntity = {
  token: "p_3c8krf49h6",
  type: "product",
  name: "Nueats, Organic 100% Grass fed Beef Jerky, Chipotle, 2.25oz",
  brandToken: "b_22qxjttyk7",
  brandName: "NuEats",
  imageUrl:
    "https://cdn.faire.com/fastly/286716f70195933da18631603aded5101c5cbed9ba426ac7d34faf1a6a2160b1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/44b58c4a96cf94ff8665d3ca0b296bfa7b2b40f8c4ede43cb4819cb333a197d1.jpeg",
    "https://cdn.faire.com/fastly/71a0395992a6bc03112dc6273291d404c77dd4cd8ef9e79c0b79f9eda0b55c6f.jpeg",
  ],
  priceDollars: 7.9,
  description:
    "100% Grass-Fed Beef, Certified Organic, U.S. inspected and passed by Department of Agriculture -No added preservatives, no added antibiotics, no hormones, no MSG, 0g trans-fat per serving -Hickory smoked, seasoned and slowly cooked to perfection",
  tags: [],
  msrpDollars: 13.16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:54:40.626Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
